import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { CSSProperties } from 'react'
import { Skill, Container, RadioBtn, DragIcon } from './styles'

type Props = {
  id: number
  index: number
  text: string
  storyID: number
  isSelected: boolean
  isSelectionAllowed: boolean
  handleSelect: (id: number, storyID: number) => void
}

const ReviewSkill = ({
  id,
  text,
  index,
  storyID,
  isSelected,
  handleSelect,
  isSelectionAllowed,
}: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled: !isSelected,
  })

  const style: CSSProperties = {
    transform: CSS.Transform.toString(
      transform ? { y: transform.y, x: 0, scaleX: 1, scaleY: 1 } : null,
    ),
    transition,
    position: 'relative',
    zIndex: isDragging ? 1 : undefined,
  }

  return (
    <Container ref={setNodeRef} style={style} {...attributes}>
      <RadioBtn
        {...{ index, isSelected, storyID, isSelectionAllowed }}
        onClick={() => handleSelect(id, storyID)}
      >
        {isSelected && index + 1}
      </RadioBtn>
      <Skill>{text}</Skill>
      <DragIcon {...{ isSelected }} {...listeners} />
    </Container>
  )
}

export default ReviewSkill
